export default __webpack_public_path__ + "static/media/pencil.f70eceb0.png";